
/**
 * Window.ts
 *
 * Module wrapping around the global window object
 */

const w = typeof window !== "undefined" && window;

/**
 * Get the IWindow object
 */
export function get(): WindowLocalStorage { return w; }

/**
 * Get the IWindow object
 */
export function getGlobal(): WindowLocalStorage { return w; }
